import { motion } from 'motion/react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OptionItemSquareWithSmileListStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 12px;
  padding: 0 16px;
`;

export const OptionItemSquareWithSmileStyles = styled(motion.div)<{
  isSelected: boolean;
}>`
  body.dark & {
    --bg-color: #765279;
    --bg-color-selected: #ffc9fb;
  }

  --square-with-smile-width: 166px;
  --bg-color: #ffffff80;
  --bg-color-selected: #ece4fd;
  background: var(--bg-color);
  box-sizing: border-box;
  width: var(--square-with-smile-width);
  aspect-ratio: 1.22;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 20px 12px;
  border-radius: 16px;

  @media screen and (max-width: 380px) {
    --square-with-smile-width: 130px;
  }

  ${({ isSelected }) => isSelected && 'background: var(--bg-color-selected);'}
`;

export const OptionItemSquareWithSmileTitleStyles = styled(UiTypography)<{
  isSelected: boolean;
}>`
  margin: 8px 0 0;

  ${({ isSelected }) => {
    if (isSelected) {
      return `
            color: #171123;
        `;
    }
  }}
`;

export const OptionItemSquareWithSmileSubtitleStyles = styled(UiTypography)<{
  isSelected: boolean;
}>`
  margin: 8px 0 0;

  ${({ isSelected }) =>
    isSelected ? 'color: #00000099;' : 'color: #FFFFFF99;'}
`;

export const OptionItemSquareWithSmileIconStyles = styled.div`
  width: 40px;
  aspect-ratio: 1/1;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
